/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};

export const setCreateUtilTapeData = (data) => {
  return {
    type: actionTypes.SET_CREATE_UTIL_TAPE_DATA,
    payload: data,
  };
};

export const setErrorMessagesData = (data) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload: data,
  };
};

export const resetCreateUtilizationTapStore = () => {
  return {
    type: actionTypes.RESET_CREATE_UTILIZATION_TAP_STORE,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_PQR,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_PQR, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturersByPQR(response.date));
    });
};

export const dispatchCalculateInvoice = (data) => {
  return {
    type: actionTypes.CALCULATE_INVOICE,
    payload: data,
  };
};

export const dispatchRebateProgByCMSReportGrp = (data) => {
  return {
    type: actionTypes.REBATE_PRGBY_CMS,
    payload: data,
  };
};

export const calculateUtilization = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CREATE_UTILIZATION_FILE, values)
    .then((response) => {
      return dispatch(dispatchCalculateInvoice(response.data));
    })
    .catch(() => {
      dispatch(dispatchCalculateInvoice({ error: 'API failed' }));
    });
};

export const getRebateProgramByCMSReportGrp = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.LIST_CMS_REBATE_PROGRAM, values)
    .then((response) => {
      return dispatch(dispatchRebateProgByCMSReportGrp(response.data));
    })
    .catch(() => {
      dispatch(dispatchRebateProgByCMSReportGrp({ error: 'API failed' }));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrCUF: data,
  };
};
export const setCMSReportingGrps = (data) => {
  return {
    type: actionTypes.SET_CMS_REPORTING_GRPS,
    cmsReportingGrps: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};
export const listCmsReportGroups = (values) => (dispatch) => {
    const queryParams = `invCUfile=true&quarter=${values}`;
  return axios
    .post(`${serviceEndPoint.LIST_UTIL_REPORT_GROUPS}?${queryParams}`)
    .then((response) => {
      return dispatch(setCMSReportingGrps(response.data));
    })
    .catch((response) => {
      dispatch(setCMSReportingGrps(response.date));
    });
};

export const updateQuarter = (quarter) => ({
  type: actionTypes.UPDATE_QUARTER,
  payload: quarter,
});
